import { recentListingStatus } from '../_config';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
function initState() {
    return {
        listingStatus: [], // listing status 列表
        listing: [], // listing 房源列表
        // 房源recent listing模块处于的状态
        fetchListingStatus: recentListingStatus.coming,
        currentListingStatus: '', // 当前选中的listingStatus
        currentListingStatusName: '', // 当前选中的listingStatus的name值，用于展示
        searchParams: {}, // search condition
        hasLocation: false,
        // 分页参数
        totalPage: 0,
        pageSize: 5,
        pageNum: 1,
        showListingPrice: true, // 是否需要显示listing price
        showSoldPrice: true, // 是否需要显示sold listing price
        soldListingInfo: null // 已售房源信息
    };
}

export default {
    namespaced: true,
    state: initState,
    getters,
    mutations,
    actions
};
